export const doesStringContain = (haystack: string, needle: string) =>
  needle && haystack.toLowerCase().includes(needle.toLowerCase())

export const doesStringStartWith = (haystack: string, needle: string) =>
  needle && haystack.toLowerCase().startsWith(needle.toLowerCase())
